import React from "react";
import {
  BatchSummaryReportDataType,
  TotalBatchSummaryDataType,
} from "../../../../redux/reports/reportsType";
import { TableLoader } from "../../../commons";
import BatchSummaryTableHeader from "./BatchSummaryTableHeader";
import BatchSummaryTableData from "./BatchSummaryTableData";

type AppProps = {
  fetching: boolean;
  currencySign: string | undefined;
  batchSummaryReportData: [] | BatchSummaryReportDataType[];
  totalBatchSummaryData: TotalBatchSummaryDataType;
};

const BatchSummaryTable = ({
  fetching,
  batchSummaryReportData,
  totalBatchSummaryData,
  currencySign,
}: AppProps) => {
  return (
    <div>
      {fetching ? (
        <TableLoader Rows={10} ColumnPerRow={8} />
      ) : (
        <div
          className="jobsType"
          //   style={{ overflowX: "scroll" }}
        >
          <table className="table table-bordered thead-light">
            <thead className="text-start">
              <BatchSummaryTableHeader />
            </thead>
            <tbody>
              <BatchSummaryTableData
                batchSummaryReportData={batchSummaryReportData}
                totalBatchSummaryData={totalBatchSummaryData}
                currencySign={currencySign}
              />
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default BatchSummaryTable;
